//Generated File 
export const Large = `Large`;
export const Medium = `Medium`;
export const Small = `Small`;
export const Tiny = `Tiny`;
export const VerySmall = `VerySmall`;
export const XLarge = `XLarge`;
export const XXLarge = `XXLarge`;
